'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTrueFalseRectangle, iconTrueFalseRectangleTag } from '@ni/nimble-components/dist/esm/icons/true-false-rectangle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTrueFalseRectangle };
export { iconTrueFalseRectangleTag };
export const NimbleIconTrueFalseRectangle = wrap(IconTrueFalseRectangle);